import { render } from "./AppStoreView.vue?vue&type=template&id=2507b93f&scoped=true"
import script from "./AppStoreView.vue?vue&type=script&lang=js"
export * from "./AppStoreView.vue?vue&type=script&lang=js"

import "./AppStoreView.vue?vue&type=style&index=0&id=2507b93f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2507b93f"]])

export default __exports__